import React, { useEffect } from "react";
import { Modal } from "react-bootstrap";
import Lottie from "react-lottie";
import * as animationData from "../../assets/lottie/Error.json";
const ErrorModel = ({ show, setShow, name = "Operation was failed!" }) => {
  useEffect(() => {
    setShow(true);
    const timer = setTimeout(() => {
      setShow(false);
    }, 3000);
    return () => clearTimeout(timer);
  }, []);

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  return (
    <Modal show={show} onHide={() => setShow(false)} centered>
      <Modal.Body className="text-center">
        <div className="success-gif">
          <Lottie
            className="success-lottie me-auto"
            width={200}
            options={defaultOptions} // Your Lottie JSON animation data
          />
        </div>
        <div style={{ color: "red", marginTop: "15px" }}>
          <h4>{name}</h4>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ErrorModel;
